import { render, staticRenderFns } from "./FileBlank.vue?vue&type=template&id=959a9bdc&"
import script from "./FileBlank.vue?vue&type=script&lang=js&"
export * from "./FileBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports